<div class="inbox-container">
  <div style="display: flex;">
    <nz-sider
      [nzCollapsedWidth]="0"
      nzCollapsible
      [(nzCollapsed)]="isCollapsed"
      [nzTrigger]="null"
      class="sideMenu messageSide"
      id="messageSider"
      nzWidth="390px"
    >
      <div>
        <div
          nz-row
          style="background-color: white; padding: 5px"
          class="messagesHeader"
        >
        <div>
          <nz-input-group nzCompact [nzSuffix]="suffixIconSearch">
            <input
              placeholder="Search..."
              type="text"
              nz-input
              [ngModel]="filterText"
              style="width: 100%"
              (ngModelChange)="filterTextChange($event)"
              [ngModelOptions]="{ updateOn: 'blur'}"
            />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <i nz-icon nzType="search"></i>
          </ng-template>
        </div>
          <div class="folderNameHead" style="display: flex">
            <button
              nz-button
              nzType="default"
              nzShape="circle"
              class="trigger"
              (click)="CollabseFolderSide()"
              style="margin-top: 15px"
            >
              <i
              style=" font-size: 15px"
                nz-icon
                [nzType]="isInboxCollapsed ? 'menu-unfold' : 'menu-fold'"
              ></i>
            </button>
            <h2 style="margin-top:13px; margin-left: 10px">
              {{ this.folderObject.Name}}
            </h2>
          </div>
          <div class="sortByDiv">
            <button
              nz-button
              nzType="default"
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menu"
            >
              <i nz-icon nzType="sort-descending" nzTheme="outline"></i>
              {{ Sortby }}
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="onOptionsSelected('Code')">Code</li>
                <li nz-menu-item (click)="onOptionsSelected('U_NAME')">From</li>
                <li nz-menu-item (click)="onOptionsSelected('Subject')">
                  Subject
                </li>
                <li nz-menu-item (click)="onOptionsSelected('RecDate')">
                  Date
                </li>
                <li nz-menu-item (click)="onOptionsSelected('WasRead')">
                  Not read
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>


        <!-- Messages cards -->
        <div nz-row>
          <div class="messagesContainer" style="width: 100%">
            <ng-container *ngFor="let item of messages">

              <app-inboxMessage (callUpdate)="updateInboxParams()" (collapse)="collapseSide()" [message]="item" (click)="updateInboxParams()"></app-inboxMessage>

            </ng-container>
          </div>
          <div nz-col nzSpan="24" class="pagination-nav">
            <nz-pagination
              nzSimple
              [nzPageIndex]="nowPage + 1"
              [nzTotal]="filteredRecords"
              (nzPageIndexChange)="changePageNav($event)"
              (nzPageSizeChange)="changePageSize($event)"
              [nzPageSize]="20"
              class="paginationBar"
            ></nz-pagination>
          </div>
        </div>
      </div>
    </nz-sider>
    <nz-content style="background: white">
      <div
        class="messageDetailsDivHeader"
        style="width: 100%; background-color: white; font-size: 20px"
      >
        <span>
          <i
            nz-icon
            nzType="arrow-left"
            class="trigger"
            nzTheme="outline"
            (click)="isCollapsed = !isCollapsed"
            style="margin-left: 10px"
          ></i>
        </span>
      </div>
      <router-outlet></router-outlet>
    </nz-content>
    <!-- </div> -->
  </div>
</div>
